import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { cn } from '../lib/utils';

export function Layout() {
  const { user, isPremium } = useAuth();
  const location = useLocation();

  const navLinks = [
    { path: '/dashboard', icon: FiIcons.FiSearch, label: 'Buscador' },
    { path: '/portfolio', icon: FiIcons.FiPieChart, label: 'Portafolio' },
    { path: '/settings', icon: FiIcons.FiSettings, label: 'Configuración' },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-brand-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16 items-center">
            <Link to="/" className="flex items-center gap-2">
              <SafeIcon icon={FiIcons.FiTrendingUp} className="text-brand-red text-2xl" />
              <span className="font-accent text-2xl font-bold text-brand-dark mt-1">
                Latinos en Wall Street
              </span>
            </Link>

            {user ? (
              <nav className="hidden md:flex space-x-8">
                {navLinks.map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    className={cn(
                      'flex items-center gap-2 px-3 py-2 text-sm font-medium transition-colors',
                      location.pathname === link.path
                        ? 'text-brand-red border-b-2 border-brand-red'
                        : 'text-brand-slate hover:text-brand-dark'
                    )}
                  >
                    <SafeIcon icon={link.icon} />
                    {link.label}
                  </Link>
                ))}
                {!isPremium && (
                  <Link to="/settings" className="flex items-center">
                    <span className="bg-gradient-to-r from-brand-red to-red-500 text-white text-xs px-2 py-1 rounded-full font-bold shadow-sm">
                      PRO
                    </span>
                  </Link>
                )}
              </nav>
            ) : (
              <div className="flex items-center gap-4">
                <Link
                  to="/login"
                  className="text-brand-slate hover:text-brand-dark font-medium text-sm"
                >
                  Iniciar Sesión
                </Link>
                <Link
                  to="/register"
                  className="bg-brand-red text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-red-800 transition"
                >
                  Comenzar Gratis
                </Link>
              </div>
            )}
          </div>
        </div>
      </header>

      {user ? (
        <div
          className="bg-brand-dark text-white text-center text-sm sm:text-base py-2.5 px-4 border-b border-white/10"
          role="status"
        >
          <span className="inline-flex flex-wrap items-center justify-center gap-2">
            <SafeIcon icon={FiIcons.FiCalendar} className="shrink-0 opacity-90" />
            <span>
              <span className="font-semibold">Prueba Beta:</span>{' '}
              estará en vivo el <time dateTime="2026-05-15">15 de mayo de 2026</time>.
            </span>
          </span>
        </div>
      ) : null}

      <main className="flex-1 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Outlet />
      </main>
    </div>
  );
}
